import { isAfter, isBefore, startOfDay, endOfDay } from 'date-fns';
import type { ReviewItem } from '@/types/api';
import { TabKey } from '../_consts/reviewsConstants';

export function filterReviewsByDate(
  orders: ReviewItem[],
  startDate?: Date,
  endDate?: Date,
): ReviewItem[] {
  if (!startDate || !endDate) return orders;
  const start = startOfDay(startDate);
  const end = endOfDay(endDate);
  return orders.filter((order) => {
    const orderDate = new Date(order.ReviewDate);
    return (
      (isAfter(orderDate, start) || orderDate.getTime() === start.getTime()) &&
      (isBefore(orderDate, end) || orderDate.getTime() === end.getTime())
    );
  });
}

export function sortReviews(reviews: ReviewItem[], sortKey: string): ReviewItem[] {
  const sorted = [...reviews];
  switch (sortKey) {
    case 'latest':
      sorted.sort((a, b) => new Date(b.ReviewDate).getTime() - new Date(a.ReviewDate).getTime());
      break;
    case 'oldest':
      sorted.sort((a, b) => new Date(a.ReviewDate).getTime() - new Date(b.ReviewDate).getTime());
      break;
    case 'highRating':
      sorted.sort((a, b) => (b.ReviewScore ?? 0) - (a.ReviewScore ?? 0));
      break;
    case 'lowRating':
      sorted.sort((a, b) => (a.ReviewScore ?? 0) - (b.ReviewScore ?? 0));
      break;
    default:
      break;
  }
  return sorted;
}

export function getTabListWithCounts(orders: ReviewItem[]) {
  const total = orders.length;
  const notYet = orders.filter(
    (r) => !r.ReviewCommentList || r.ReviewCommentList.length === 0,
  ).length;
  const completed = orders.filter(
    (r) => r.ReviewCommentList && r.ReviewCommentList.length > 0,
  ).length;

  return [
    { key: 'whole', label: '전체 리뷰', count: total },
    { key: 'not-yet', label: '미답변', count: notYet },
    { key: 'completed', label: '답변완료', count: completed },
  ];
}

export function filterReviewsByTab(reviews: ReviewItem[], tab: TabKey): ReviewItem[] {
  switch (tab) {
    case 'not-yet':
      return reviews.filter((r) => !r.ReviewCommentList || r.ReviewCommentList.length === 0);
    case 'completed':
      return reviews.filter((r) => r.ReviewCommentList && r.ReviewCommentList.length > 0);
    case 'whole':
    default:
      return reviews;
  }
}
